import { CcReviewReviewType } from "server/models"
import { inferLiteral } from "client/utils"
import * as types from "./types"


export const setCcReviewReviewTypeList = (typeList: types.CcReviewReviewTypeList) => ({
    type: inferLiteral(types.CC_REVIEW_REVIEW_TYPE_LIST),
    typeList,
})
export const setCcReviewReviewTypeIds = (typeIds: readonly number[]) => ({
    type: inferLiteral(types.CC_REVIEW_REVIEW_TYPE_IDS),
    typeIds,
})
export const setCcReviewReviewTypeEdit = (value: CcReviewReviewType) => ({
    type: inferLiteral(types.CC_REVIEW_REVIEW_TYPE_EDIT),
    value,
})
export const setCcReviewReviewTypeReloadList = (value: boolean) => ({
    type: inferLiteral(types.CC_REVIEW_REVIEW_TYPE_RELOAD_LIST),
    value,
})
export const setCcReviewReviewTypeReloadEdit = (value: boolean) => ({
    type: inferLiteral(types.CC_REVIEW_REVIEW_TYPE_RELOAD_EDIT),
    value,
})
